import { set as _set } from 'lodash-es';

/**
 * @typedef {Object} ValidationError
 * @property {string} message - The formatted error message
 * @property {string} [tooltip] - Optional tooltip message
 */

const buildErrorMessage = (intl, error) => {
  const errorMessageDescriptor = error.message?.messageDescriptor;
  const errorMessageValues = error.message?.values || {};
  const tooltipMessageDescriptor = error.message?.tooltipDescriptor;
  const message = errorMessageDescriptor ? intl.formatMessage(errorMessageDescriptor, errorMessageValues) : error.message;
  const tooltip = tooltipMessageDescriptor && intl.formatMessage(tooltipMessageDescriptor);
  return {
    message,
    tooltip,
  };
};

export const errorHandler = (intl, validationError) => {
  return (
    validationError?.inner?.reduce((aggErrors, error) => {
      _set(aggErrors, error.path, {
        ...error,
        ...buildErrorMessage(intl, error),
      });
      return aggErrors;
    }, {}) || {}
  );
};

export const buildMessageCallback = (messageDescriptor, rest) => () => ({
  ...rest,
  messageDescriptor,
});

/**
 * Extracts the error message string from a validation error object or string
 * @param {ValidationError|string|undefined} error - Validation error (can be an object with message property or a string)
 * @returns {string|undefined} The error message string, or undefined if no error
 */
export const getErrorMessage = (error) => {
  if (!error) {
    return undefined;
  }
  if (typeof error === 'string') {
    return error;
  }
  return error.message;
};
